var _path, _circle, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProdejnyMapPathVerona(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "96.333px",
    height: "113.834px",
    viewBox: "0 0 96.333 113.834",
    enableBackground: "new 0 0 96.333 113.834",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.693,54.179c0.928-1.259,0.659-3.031-0.6-3.957c-1.259-0.931-3.029-0.663-3.959,0.596 c-0.933,1.257-0.661,3.028,0.597,3.96C50.991,55.706,52.763,55.438,53.693,54.179"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    cx: 8.157,
    cy: 107.033,
    r: 2.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeDasharray: "5,5",
    d: "M9.989,106.533 c20.712-6.466,39.642-27.135,41.425-53.312"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProdejnyMapPathVerona);
export default __webpack_public_path__ + "static/media/prodejny_map_path_verona.2c9ade574db1c943024055e750b1bff3.svg";
export { ForwardRef as ReactComponent };